import { render, staticRenderFns } from "./LayoutConfigForm.vue?vue&type=template&id=13909f88&"
import script from "./LayoutConfigForm.vue?vue&type=script&lang=js&"
export * from "./LayoutConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports